import { useState, useEffect } from 'react';
import MyButton from './MyButton';

function TickingClock() {

  const [currentTime, setTime] = useState(new Date().toLocaleTimeString());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 100)
    return () => clearInterval(interval)
  }, [currentTime])

  return (
      currentTime
  );
}

/*
  Backend call
 */
function HelloWorld() {

  const [data, setData] = useState({message: ""});
  const [timeoutValue, setTimeoutValue] = useState(0);

  useEffect(() => {
    const interval = setTimeout(() => {
      setTimeoutValue(10_000); // From now on we want to fetch every 10s
      fetch('/api/helloWorld?name=Bjorn')
          .then(response => response.json())
          .then(json => setData(json))
          .catch(error => console.error(error));
    }, timeoutValue)
    return () => clearTimeout(interval)
  }, [data, timeoutValue])

  return (
      <>
        <br />
        {data.message}
        <h1>Hello</h1>
      </>
  );
}

function LatestIpNumbers() {

  const [data, setData] = useState({ipnumbers: []});

  useEffect(() => {
    fetch('/api/ipnumbers')
        .then(response => response.json())
        .then(json => setData(json))
        .catch(error => console.error(error));
  }, []);

  return (
      <table>
          <thead>
            <tr>
                <th>Ip address</th>
                <th>Latest request</th>
                <th>First request</th>
                <th>Request count</th>
            </tr>
          </thead>
          <tbody>
                {
                    data.ipnumbers.map(ipNumber =>
                        <tr key={ipNumber["remote_ip_address_log_ip_address"]}>
                            <td>{ipNumber["remote_ip_address_log_ip_address"]}</td>
                            <td>
                                {new Date(ipNumber["_max_logged_at"]).toLocaleDateString()} {new Date(ipNumber["_max_logged_at"]).toLocaleTimeString()}
                            </td>
                            <td>
                                {new Date(ipNumber["_min_logged_at"]).toLocaleDateString()} {new Date(ipNumber["_min_logged_at"]).toLocaleTimeString()}
                            </td>
                            <td>{ipNumber["_count_logged_at"]}</td>
                        </tr>
                    )
                }
          </tbody>
      </table>
  );
}


function App() {
  return (
      <>
        {/*<TickingClock />*/}
        {/*<HelloWorld />*/}
        <LatestIpNumbers />
        {/*<MyButton title={"Hello"}></MyButton>*/}
      </>
  );
}

export default App;
